<template>

    <v-card  class="pb-80" >
        <v-card-text>
            <v-card class="top-card " >
                    <v-row class="pl-3 pr-3">
                        <v-col cols="2" md="2" sm="2" class="" align="center" justify="center" >
                            <div class="fill-height d-flex align-center ">
                                <div class="w-100">
                                    <v-img :src="tapsImg" width="40" height="40"></v-img>
                                </div>    
                            </div>
                        </v-col>
                        <v-col cols="8" md="8" sm="8" class="d-flex align-center">
                            <div class="emr-text">If you need urgent medical assistance<br>
                                <div class="tap-here">TAP HERE NOW!</div>
                            </div>
                            
                            
                        </v-col>

                        <v-col cols="2" md="2" sm="2">
                            <div class="fill-height d-flex align-center ">
                                <div class="w-100">
                                <v-img :src="tapsImg" width="40" height="40"></v-img>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
            </v-card>

            <v-row class="mt-30">
                <v-col cols="12" md="12" sm="12">
                    <div class="heading">NOT FEELING WELL?</div>

                </v-col>
            </v-row>

            <v-row class="mt-30">
                <v-col cols="12" md="12" sm="12">
                    <div class="sub-title">Tap to select which of the following symptoms you are suffering from</div>

                </v-col>
            </v-row>

            <v-row class="mt-30">
                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="vomittingImg" width="73" height="79" contain></v-img></div>
                    <div class="img-txt">VOMITTING</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="feverImg" width="38" height="79" contain></v-img></div>
                    <div class="img-txt">FEVER</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center">
                        <v-img :src="diarrheaImg" width="51" height="79" contain></v-img></div>
                    <div class="img-txt">DIARRHEA</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center" style="height:79px"><v-img :src="chillsImg" width="32" contain></v-img></div>
                    <div class="img-txt">CHILLS</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="tiredImg" width="23" height="79" contain></v-img></div>
                    <div class="img-txt">TIRED</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="coughImg" width="23" height="79" contain></v-img></div>
                    <div class="img-txt">COUGH</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="sunburnImg" width="23" height="79" contain></v-img></div>
                    <div class="img-txt">SUNBURN</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="abdominalImg" width="76" height="79" contain></v-img></div>
                    <div class="img-txt">ABDOMINAL</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="appetiteImg" width="76" height="79" contain></v-img></div>
                    <div class="img-txt">APPETITE</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="nauseaImg" width="76" height="79" contain></v-img></div>
                    <div class="img-txt">NAUSEA</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="achesImg" width="37" height="79" contain></v-img></div>
                    <div class="img-txt">ACHES</div>
                </v-col>

                <v-col cols="3" md="3" sm="3" class="bdr-r-b">
                    <div class="d-flex justify-center"><v-img :src="soreImg" width="46" height="79" contain ></v-img></div>
                    <div class="img-txt">SORE THROAT</div>
                </v-col>

            </v-row>

            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <div class="skip">SKIP ALL</div>
                </v-col>

            </v-row>

            <v-row >
                <v-col cols="12" sm="12" md="12" class="text-center" >
                    <v-btn class="view" color="#7697A1" light>VIEW RECOMMENDATIONS</v-btn>
                    
                </v-col>

            </v-row>

        </v-card-text>
    </v-card>
    
</template>
<script>
import Vue from 'vue'
export default {
    data: () => ({
    tapsImg:require('@/assets/tap-s.png'),
    emrImg:require('@/assets/emergency.png'),
    tapImg:require('@/assets/tap.png'),
    coughImg:require('@/assets/cough.png'),
    tiredImg:require('@/assets/tired.png'),
    chillsImg:require('@/assets/chills.png'),
    diarrheaImg:require('@/assets/DIARRHEA.png'),

    feverImg:require('@/assets/fever.png'),
    vomittingImg:require('@/assets/vomitting.png'),
    sunburnImg:require('@/assets/sunburn.png'),

    abdominalImg:require('@/assets/abdominal.png'),

    appetiteImg:require('@/assets/appetite.png'),
    nauseaImg:require('@/assets/nausea.png'),

    achesImg:require('@/assets/aches.png'),

    soreImg:require('@/assets/sore.png'),
    
    }),
}
</script>
<style>
    .view-container{
        
    }
    .view{
        color:#fff !important;
        font-size: 22px;
        text-align: center;
        
    }
    .skip{
        color: #7697A1;
        font-size:14px;
        font-weight: normal;
        text-align: right;
    }
    .heading{
        color: #7697A1;
        font-size:32px;
        font-weight: bold;
        text-align: center;
    }
    .mt-30{
        margin-top: 30px;
    }
    .sub-title{
        color:#536B72;
        font-size:14px;
        text-align: center;
    }
    .img-txt{
        color: #FE5800;
        font-size:10px;
        font-weight: bold;
    }
    .bdr-r-b
    {
        border-right: 1px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        text-align: center;
    }
    .top-card
    {
        background: #D80027;
    }
    .emr-text{
        color: #FEC83D;
        font-size:11px;
    }
    .tap-here{
        color: #FEC83D;
        font-size: 20px;
        text-align: center;
    }
</style>